import ITipoDeDeficiencia from '../../interfaces/ITipoDeDeficiencia';
import ITipoDeDeficienciaParaSelect from '../../interfaces/ITipoDeDeficienciaParaSelect';

export const mapearTiposDeDeficienciaParaSelect = (tipoDeficiencias: ITipoDeDeficiencia[]): ITipoDeDeficienciaParaSelect[] =>
  tipoDeficiencias.map(({ id, nome }) => ({
    value: id,
    label: nome
  }));